import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
